import { useEffect, useState } from 'react';
import styled from 'styled-components';
import OverlayResults from '@routes/userRoutes/projects/videoProject/components/overlay/OverlayResults';

/**
 * Development only (registered when import.meta.env.DEV): the video results overlay on local sample artifacts,
 * /dev/video-overlay?sample=<name> reads public/dev-overlay/<name>/{tracks.json, clean_video.mp4, statistics.json}
 * (made by the backend's reports/overlay_dev/make_samples.py; not committed).
 */

const Page = styled.div`
	min-height: 100vh;
	background: ${({ theme }) => theme.colors.background};
	padding: 1.25rem;
	color: ${({ theme }) => theme.colors.textColor};
`;

const Bar = styled.div`
	display: flex;
	gap: 0.6rem;
	align-items: center;
	margin-bottom: 1rem;
	a {
		color: ${({ theme }) => theme.colors.linkColor};
	}
`;

const SAMPLES = ['snow_1m34', 'customer_line'];

const OverlayDevPage = () => {
	const sample = new URLSearchParams(window.location.search).get('sample') || SAMPLES[0];
	const base = `/dev-overlay/${sample}`;
	const [tracks, setTracks] = useState(null);
	const [stats, setStats] = useState(null);
	const [error, setError] = useState(null);

	useEffect(() => {
		Promise.all([
			fetch(`${base}/tracks.json`).then(r => r.json()),
			fetch(`${base}/statistics.json`).then(r => r.json()),
		])
			.then(([t, s]) => {
				setTracks(t);
				setStats(s);
			})
			.catch(e => setError(String(e)));
	}, [base]);

	return (
		<Page>
			<Bar>
				<b>Overlay dev</b>
				{SAMPLES.map(s => (
					<a key={s} href={`?sample=${s}`}>
						{s}
					</a>
				))}
			</Bar>
			{error && (
				<div>
					Could not load {base}: {error}
				</div>
			)}
			{tracks && (
				<OverlayResults
					tracksDoc={tracks}
					videoSrc={`${base}/clean_video.mp4`}
					statistics={stats}
					virtualLine={stats?.virtual_line}
				/>
			)}
		</Page>
	);
};

export default OverlayDevPage;
